import './verificationPage.scss';

import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { FormEvent,
  ReactNode,} from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import heroDesigner from '../../../assets/hero-designer.svg';
import logo from '../../../assets/logo-default.svg';
import { NavigationPane } from '../../../components/NavigationPane/NavigationPane';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import useNavigationPaneStore from '../../../store/navigationPaneStore/useNavigationPaneStore';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import { locator } from '../../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { setDrawerOpen } = useNavigationPaneStore();

  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const formSubmit = (event: FormEvent): void => {
    event.preventDefault();

    navigate(`/verifications/${vehicleId}/document-list`);
  };

  return (
    <div className="verification-page">
      <ThemeProvider theme={theme}>
        <Box sx={theme.pageLayout}>
          <header data-testid={locator.pages.verification.header.root}>
            <img alt={t('imageAlts.logo')} src={logo} />
            <button
              aria-label="Toggle drawer"
              data-testid={locator.pages.verification.header.drawerButton}
              type="button"
              onClick={(): void => {
                setDrawerOpen(true);
              }}
            >
              <MenuRoundedIcon />
            </button>
          </header>

          <main>
            <figure>
              <img alt={t('imageAlts.heroDesigner')} src={heroDesigner} />
            </figure>
            <form
              data-testid={locator.pages.verification.form.root}
              noValidate
              onSubmit={formSubmit}
            >
              <div className="form-content">
                <h1 data-testid={locator.pages.verification.form.h1}>
                  {t('VerificationPage.title')}
                </h1>
                <h2 data-testid={locator.pages.verification.form.h2}>
                  {t('VerificationPage.subtitle')}
                </h2>

                <div style={{ marginBottom: '3rem' }}>
                  <Button
                    color="primary"
                    data-testid={locator.pages.verification.form.submitButton}
                    startIcon={<></>}
                    type="submit"
                    variant="contained"
                    fullWidth
                  >
                    {t('VerificationPage.continue')}
                  </Button>
                </div>
              </div>
              <footer data-testid={locator.pages.verification.footer.root}>
                {t('copyright', { year: new Date().getFullYear() })}
              </footer>
            </form>
          </main>
        </Box>

        <NavigationPane withDrawer withUserNameHeader />
      </ThemeProvider>
    </div>
  );
}

Component.displayName = 'VerificationPage';
